import { Split } from 'lucide-react';
import { Button } from '../ui/button';
import { eur, frDate } from './api';

export function SplitDraftBanner({ r, onOpen }) {
    const missing = (r.lignes || []).filter(l => l.type === 'vehicule' && !l.vehicle_id);
    return (
        <div className="rounded-xl border border-indigo-200 bg-indigo-50/60 p-3 flex flex-col sm:flex-row sm:items-center gap-2 justify-between" data-testid="split-draft-banner">
            <div className="text-[12px] text-indigo-900">
                <p><b>Répartition préparée</b> par {r.par} le {frDate(r.le)} : {r.lignes?.length} lignes, {eur(r.reparti_ttc)} / {eur(r.total_ttc)} — aucune conséquence financière.</p>
                {missing.length > 0 && <p className="text-amber-700" data-testid="split-draft-missing">Véhicule introuvable : {missing.map(l => l.immatriculation || '?').join(', ')}</p>}
            </div>
            <Button size="sm" variant="outline" onClick={onOpen} data-testid="split-draft-resume"><Split className="w-4 h-4 mr-1" />Reprendre</Button>
        </div>
    );
}

export function SplitSummary({ a }) {
    return (
        <div className="rounded-xl border border-gray-200 overflow-hidden" data-testid="split-summary">
            <p className="px-3 py-2 text-[11px] uppercase tracking-wider text-gray-400 bg-gray-50">Répartition validée par {a.par} le {frDate(a.le)} — {eur(a.total_ttc)} TTC</p>
            <ul className="divide-y divide-gray-50">
                {a.lignes.map((l, i) => (
                    <li key={i} className="px-3 py-2 text-[12px] flex flex-wrap items-center gap-x-3 gap-y-0.5" data-testid={`split-summary-line-${i}`}>
                        <span className="font-mono font-semibold w-24">{l.type === 'agence' ? 'Agence' : l.immatriculation}</span>
                        <span className="text-gray-500 flex-1 min-w-0 truncate">{l.type === 'agence' ? `Charge ${l.categorie}` : `${l.nom || ''} · ${l.commercial || '—'}`}{l.lien_existant ? ' · dépense existante' : ''}{l.description ? ` · ${l.description}` : ''}</span>
                        <span className="font-mono text-gray-500">HT {eur(l.montant_ht)}</span>
                        <span className="font-mono font-semibold">{eur(l.montant_ttc)}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
